export default __webpack_public_path__ + "static/media/articlelist.dc5afe8b.png";